// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file call/call_model.proto (package com.gem.vcs.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenEnum, GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { enumDesc, fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

/**
 * Describes the file call/call_model.proto.
 */
export const file_call_call_model: GenFile =
  /*@__PURE__*/
  fileDesc(
    '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'
  );

/**
 * @generated from message com.gem.vcs.contract.Call
 */
export type Call = Message<'com.gem.vcs.contract.Call'> & {
  /**
   * @generated from field: string channelId = 1;
   */
  channelId: string;

  /**
   * @generated from field: com.gem.vcs.contract.Call.Status status = 3;
   */
  status: Call_Status;

  /**
   * @generated from field: com.gem.vcs.contract.CallSettings settings = 5;
   */
  settings?: CallSettings;

  /**
   * @generated from field: optional string actualRecordingId = 6;
   */
  actualRecordingId?: string;

  /**
   * @generated from field: optional string callName = 7;
   */
  callName?: string;

  /**
   * @generated from field: int64 approxDurationMs = 8;
   */
  approxDurationMs: bigint;
};

/**
 * Describes the message com.gem.vcs.contract.Call.
 * Use `create(CallSchema)` to create a new message.
 */
export const CallSchema: GenMessage<Call> = /*@__PURE__*/ messageDesc(file_call_call_model, 0);

/**
 * @generated from enum com.gem.vcs.contract.Call.Status
 */
export enum Call_Status {
  /**
   * @generated from enum value: IN_PROGRESS = 0;
   */
  IN_PROGRESS = 0,

  /**
   * @generated from enum value: DECLINED = 1;
   */
  DECLINED = 1,

  /**
   * @generated from enum value: UNANSWERED = 2;
   */
  UNANSWERED = 2,

  /**
   * @generated from enum value: FINISHED = 3;
   */
  FINISHED = 3,
}

/**
 * Describes the enum com.gem.vcs.contract.Call.Status.
 */
export const Call_StatusSchema: GenEnum<Call_Status> =
  /*@__PURE__*/
  enumDesc(file_call_call_model, 0, 0);

/**
 * @generated from enum com.gem.vcs.contract.Call.FinishReason
 */
export enum Call_FinishReason {
  /**
   * @generated from enum value: DURATION_LIMIT_REACHED = 0;
   */
  DURATION_LIMIT_REACHED = 0,
}

/**
 * Describes the enum com.gem.vcs.contract.Call.FinishReason.
 */
export const Call_FinishReasonSchema: GenEnum<Call_FinishReason> =
  /*@__PURE__*/
  enumDesc(file_call_call_model, 0, 1);

/**
 * @generated from message com.gem.vcs.contract.CallMember
 */
export type CallMember = Message<'com.gem.vcs.contract.CallMember'> & {
  /**
   * @generated from field: int64 memberId = 1;
   */
  memberId: bigint;

  /**
   * @generated from field: string userName = 2 [deprecated = true];
   * @deprecated
   */
  userName: string;

  /**
   * @generated from field: optional string avatarUrl = 3 [deprecated = true];
   * @deprecated
   */
  avatarUrl?: string;

  /**
   * @generated from field: com.gem.vcs.contract.CallMember.DisplayData displayData = 7;
   */
  displayData?: CallMember_DisplayData;

  /**
   * @generated from field: com.gem.vcs.contract.CallMemberDevice device = 4;
   */
  device?: CallMemberDevice;

  /**
   * @generated from field: com.gem.vcs.contract.CallMember.Status status = 5;
   */
  status: CallMember_Status;

  /**
   * @generated from field: bool isAdmin = 6;
   */
  isAdmin: boolean;
};

/**
 * Describes the message com.gem.vcs.contract.CallMember.
 * Use `create(CallMemberSchema)` to create a new message.
 */
export const CallMemberSchema: GenMessage<CallMember> =
  /*@__PURE__*/
  messageDesc(file_call_call_model, 1);

/**
 * @generated from message com.gem.vcs.contract.CallMember.DisplayData
 */
export type CallMember_DisplayData = Message<'com.gem.vcs.contract.CallMember.DisplayData'> & {
  /**
   * @generated from field: string userName = 1;
   */
  userName: string;

  /**
   * @generated from field: optional string avatarUrl = 2;
   */
  avatarUrl?: string;
};

/**
 * Describes the message com.gem.vcs.contract.CallMember.DisplayData.
 * Use `create(CallMember_DisplayDataSchema)` to create a new message.
 */
export const CallMember_DisplayDataSchema: GenMessage<CallMember_DisplayData> =
  /*@__PURE__*/
  messageDesc(file_call_call_model, 1, 0);

/**
 * @generated from enum com.gem.vcs.contract.CallMember.Status
 */
export enum CallMember_Status {
  /**
   * @generated from enum value: INITIATED = 0;
   */
  INITIATED = 0,

  /**
   * @generated from enum value: JOINED = 1;
   */
  JOINED = 1,

  /**
   * @generated from enum value: DECLINED = 2;
   */
  DECLINED = 2,

  /**
   * @generated from enum value: LEFT = 3;
   */
  LEFT = 3,
}

/**
 * Describes the enum com.gem.vcs.contract.CallMember.Status.
 */
export const CallMember_StatusSchema: GenEnum<CallMember_Status> =
  /*@__PURE__*/
  enumDesc(file_call_call_model, 1, 0);

/**
 * @generated from enum com.gem.vcs.contract.CallMember.Role
 */
export enum CallMember_Role {
  /**
   * @generated from enum value: SUPERUSER = 0;
   */
  SUPERUSER = 0,

  /**
   * @generated from enum value: MEMBER = 1;
   */
  MEMBER = 1,

  /**
   * @generated from enum value: GUEST = 2;
   */
  GUEST = 2,
}

/**
 * Describes the enum com.gem.vcs.contract.CallMember.Role.
 */
export const CallMember_RoleSchema: GenEnum<CallMember_Role> =
  /*@__PURE__*/
  enumDesc(file_call_call_model, 1, 1);

/**
 * @generated from message com.gem.vcs.contract.CallMemberSelfData
 */
export type CallMemberSelfData = Message<'com.gem.vcs.contract.CallMemberSelfData'> & {
  /**
   * @generated from field: com.gem.vcs.contract.CallMember member = 1;
   */
  member?: CallMember;

  /**
   * @generated from field: string cameraToken = 2;
   */
  cameraToken: string;

  /**
   * @generated from field: string screenToken = 3;
   */
  screenToken: string;

  /**
   * @generated from field: com.gem.vcs.contract.CallMemberPermissions permissions = 4;
   */
  permissions?: CallMemberPermissions;

  /**
   * @generated from field: com.gem.vcs.contract.CallUiConfiguration callUiConfiguration = 5;
   */
  callUiConfiguration?: CallUiConfiguration;
};

/**
 * Describes the message com.gem.vcs.contract.CallMemberSelfData.
 * Use `create(CallMemberSelfDataSchema)` to create a new message.
 */
export const CallMemberSelfDataSchema: GenMessage<CallMemberSelfData> =
  /*@__PURE__*/
  messageDesc(file_call_call_model, 2);

/**
 * @generated from message com.gem.vcs.contract.CallMemberPermissions
 */
export type CallMemberPermissions = Message<'com.gem.vcs.contract.CallMemberPermissions'> & {
  /**
   * @generated from field: com.gem.vcs.contract.PersonalizedCallPermissions personalized = 1;
   */
  personalized?: PersonalizedCallPermissions;

  /**
   * @generated from field: com.gem.vcs.contract.CallPermissions default = 2;
   */
  default?: CallPermissions;

  /**
   * @generated from field: com.gem.vcs.contract.PersonalizedCallPermissions defaultPersonalized = 3;
   */
  defaultPersonalized?: PersonalizedCallPermissions;
};

/**
 * Describes the message com.gem.vcs.contract.CallMemberPermissions.
 * Use `create(CallMemberPermissionsSchema)` to create a new message.
 */
export const CallMemberPermissionsSchema: GenMessage<CallMemberPermissions> =
  /*@__PURE__*/
  messageDesc(file_call_call_model, 3);

/**
 * @generated from message com.gem.vcs.contract.CallInfo
 */
export type CallInfo = Message<'com.gem.vcs.contract.CallInfo'> & {
  /**
   * @generated from field: com.gem.vcs.contract.Call call = 1;
   */
  call?: Call;

  /**
   * @generated from field: com.gem.vcs.contract.CallMember initiatorData = 2 [deprecated = true];
   * @deprecated
   */
  initiatorData?: CallMember;

  /**
   * @generated from field: int64 initiatorId = 4;
   */
  initiatorId: bigint;

  /**
   * @generated from field: com.gem.vcs.contract.CallMemberSelfData selfData = 3;
   */
  selfData?: CallMemberSelfData;
};

/**
 * Describes the message com.gem.vcs.contract.CallInfo.
 * Use `create(CallInfoSchema)` to create a new message.
 */
export const CallInfoSchema: GenMessage<CallInfo> =
  /*@__PURE__*/
  messageDesc(file_call_call_model, 4);

/**
 * @generated from message com.gem.vcs.contract.CallSettings
 */
export type CallSettings = Message<'com.gem.vcs.contract.CallSettings'> & {
  /**
   * @generated from field: int32 maxBroadcasters = 1;
   */
  maxBroadcasters: number;

  /**
   * @generated from field: int32 callVisibleDurationMs = 2;
   */
  callVisibleDurationMs: number;

  /**
   * @generated from field: bool waitingRoomEnabled = 3;
   */
  waitingRoomEnabled: boolean;

  /**
   * @generated from field: bool guestsAllowed = 4;
   */
  guestsAllowed: boolean;

  /**
   * @generated from field: com.gem.vcs.contract.VideoQualitySettings videoQualitySettings = 5;
   */
  videoQualitySettings?: VideoQualitySettings;

  /**
   * @generated from field: int32 maxParticipants = 6;
   */
  maxParticipants: number;

  /**
   * @generated from field: optional int32 maxParticipantsReminder = 7;
   */
  maxParticipantsReminder?: number;

  /**
   * @generated from field: optional int64 maxDurationMs = 8;
   */
  maxDurationMs?: bigint;

  /**
   * @generated from field: optional int64 maxDurationReminderMs = 9;
   */
  maxDurationReminderMs?: bigint;
};

/**
 * Describes the message com.gem.vcs.contract.CallSettings.
 * Use `create(CallSettingsSchema)` to create a new message.
 */
export const CallSettingsSchema: GenMessage<CallSettings> =
  /*@__PURE__*/
  messageDesc(file_call_call_model, 5);

/**
 * @generated from message com.gem.vcs.contract.VideoQualitySettings
 */
export type VideoQualitySettings = Message<'com.gem.vcs.contract.VideoQualitySettings'> & {
  /**
   * @generated from field: com.gem.vcs.contract.VideoQualityPreset low = 1;
   */
  low?: VideoQualityPreset;

  /**
   * @generated from field: com.gem.vcs.contract.VideoQualityPreset medium = 2;
   */
  medium?: VideoQualityPreset;

  /**
   * @generated from field: com.gem.vcs.contract.VideoQualityPreset high = 3;
   */
  high?: VideoQualityPreset;
};

/**
 * Describes the message com.gem.vcs.contract.VideoQualitySettings.
 * Use `create(VideoQualitySettingsSchema)` to create a new message.
 */
export const VideoQualitySettingsSchema: GenMessage<VideoQualitySettings> =
  /*@__PURE__*/
  messageDesc(file_call_call_model, 6);

/**
 * @generated from message com.gem.vcs.contract.VideoQualityPreset
 */
export type VideoQualityPreset = Message<'com.gem.vcs.contract.VideoQualityPreset'> & {
  /**
   * @generated from field: com.gem.vcs.contract.VideoResolution resolution = 1;
   */
  resolution: VideoResolution;

  /**
   * @generated from field: int32 maxBitrate = 2;
   */
  maxBitrate: number;

  /**
   * @generated from field: int32 maxFps = 3;
   */
  maxFps: number;
};

/**
 * Describes the message com.gem.vcs.contract.VideoQualityPreset.
 * Use `create(VideoQualityPresetSchema)` to create a new message.
 */
export const VideoQualityPresetSchema: GenMessage<VideoQualityPreset> =
  /*@__PURE__*/
  messageDesc(file_call_call_model, 7);

/**
 * @generated from message com.gem.vcs.contract.CallMemberDevice
 */
export type CallMemberDevice = Message<'com.gem.vcs.contract.CallMemberDevice'> & {
  /**
   * @generated from field: string cameraId = 1;
   */
  cameraId: string;

  /**
   * @generated from field: string screenId = 2;
   */
  screenId: string;

  /**
   * @generated from field: string deviceId = 3;
   */
  deviceId: string;
};

/**
 * Describes the message com.gem.vcs.contract.CallMemberDevice.
 * Use `create(CallMemberDeviceSchema)` to create a new message.
 */
export const CallMemberDeviceSchema: GenMessage<CallMemberDevice> =
  /*@__PURE__*/
  messageDesc(file_call_call_model, 8);

/**
 * @generated from message com.gem.vcs.contract.CallRecording
 */
export type CallRecording = Message<'com.gem.vcs.contract.CallRecording'> & {};

/**
 * Describes the message com.gem.vcs.contract.CallRecording.
 * Use `create(CallRecordingSchema)` to create a new message.
 */
export const CallRecordingSchema: GenMessage<CallRecording> =
  /*@__PURE__*/
  messageDesc(file_call_call_model, 9);

/**
 * @generated from enum com.gem.vcs.contract.CallRecording.Type
 */
export enum CallRecording_Type {
  /**
   * @generated from enum value: AUDIO = 0;
   */
  AUDIO = 0,

  /**
   * @generated from enum value: AUDIO_VIDEO = 1;
   */
  AUDIO_VIDEO = 1,
}

/**
 * Describes the enum com.gem.vcs.contract.CallRecording.Type.
 */
export const CallRecording_TypeSchema: GenEnum<CallRecording_Type> =
  /*@__PURE__*/
  enumDesc(file_call_call_model, 9, 0);

/**
 * @generated from message com.gem.vcs.contract.CallPermissions
 */
export type CallPermissions = Message<'com.gem.vcs.contract.CallPermissions'> & {
  /**
   * @generated from field: com.gem.vcs.contract.CallPermissions.Level switchOnCamera = 1;
   */
  switchOnCamera: CallPermissions_Level;

  /**
   * @generated from field: com.gem.vcs.contract.CallPermissions.Level switchOnMic = 2;
   */
  switchOnMic: CallPermissions_Level;

  /**
   * @generated from field: com.gem.vcs.contract.CallPermissions.Level shareScreen = 3;
   */
  shareScreen: CallPermissions_Level;
};

/**
 * Describes the message com.gem.vcs.contract.CallPermissions.
 * Use `create(CallPermissionsSchema)` to create a new message.
 */
export const CallPermissionsSchema: GenMessage<CallPermissions> =
  /*@__PURE__*/
  messageDesc(file_call_call_model, 10);

/**
 * @generated from enum com.gem.vcs.contract.CallPermissions.Level
 */
export enum CallPermissions_Level {
  /**
   * @generated from enum value: EVERYONE = 0;
   */
  EVERYONE = 0,

  /**
   * @generated from enum value: AFTER_APPROVE = 1;
   */
  AFTER_APPROVE = 1,

  /**
   * @generated from enum value: ADMINS_AND_OWNER = 2;
   */
  ADMINS_AND_OWNER = 2,
}

/**
 * Describes the enum com.gem.vcs.contract.CallPermissions.Level.
 */
export const CallPermissions_LevelSchema: GenEnum<CallPermissions_Level> =
  /*@__PURE__*/
  enumDesc(file_call_call_model, 10, 0);

/**
 * @generated from message com.gem.vcs.contract.PersonalizedCallPermissions
 */
export type PersonalizedCallPermissions =
  Message<'com.gem.vcs.contract.PersonalizedCallPermissions'> & {
    /**
     * @generated from field: optional com.gem.vcs.contract.PersonalizedCallPermissions.Level switchOnCamera = 1;
     */
    switchOnCamera?: PersonalizedCallPermissions_Level;

    /**
     * @generated from field: optional com.gem.vcs.contract.PersonalizedCallPermissions.Level switchOnMic = 2;
     */
    switchOnMic?: PersonalizedCallPermissions_Level;

    /**
     * @generated from field: optional com.gem.vcs.contract.PersonalizedCallPermissions.Level shareScreen = 3;
     */
    shareScreen?: PersonalizedCallPermissions_Level;
  };

/**
 * Describes the message com.gem.vcs.contract.PersonalizedCallPermissions.
 * Use `create(PersonalizedCallPermissionsSchema)` to create a new message.
 */
export const PersonalizedCallPermissionsSchema: GenMessage<PersonalizedCallPermissions> =
  /*@__PURE__*/
  messageDesc(file_call_call_model, 11);

/**
 * @generated from enum com.gem.vcs.contract.PersonalizedCallPermissions.Level
 */
export enum PersonalizedCallPermissions_Level {
  /**
   * @generated from enum value: ALWAYS = 0;
   */
  ALWAYS = 0,

  /**
   * @generated from enum value: NEVER = 1;
   */
  NEVER = 1,

  /**
   * @generated from enum value: AFTER_APPROVE = 2;
   */
  AFTER_APPROVE = 2,
}

/**
 * Describes the enum com.gem.vcs.contract.PersonalizedCallPermissions.Level.
 */
export const PersonalizedCallPermissions_LevelSchema: GenEnum<PersonalizedCallPermissions_Level> =
  /*@__PURE__*/
  enumDesc(file_call_call_model, 11, 0);

/**
 * @generated from message com.gem.vcs.contract.MemberWithCustomPermissions
 */
export type MemberWithCustomPermissions =
  Message<'com.gem.vcs.contract.MemberWithCustomPermissions'> & {
    /**
     * @generated from field: int64 memberId = 1;
     */
    memberId: bigint;

    /**
     * @generated from field: com.gem.vcs.contract.PersonalizedCallPermissions personalized = 2;
     */
    personalized?: PersonalizedCallPermissions;
  };

/**
 * Describes the message com.gem.vcs.contract.MemberWithCustomPermissions.
 * Use `create(MemberWithCustomPermissionsSchema)` to create a new message.
 */
export const MemberWithCustomPermissionsSchema: GenMessage<MemberWithCustomPermissions> =
  /*@__PURE__*/
  messageDesc(file_call_call_model, 12);

/**
 * @generated from message com.gem.vcs.contract.CallPermission
 */
export type CallPermission = Message<'com.gem.vcs.contract.CallPermission'> & {};

/**
 * Describes the message com.gem.vcs.contract.CallPermission.
 * Use `create(CallPermissionSchema)` to create a new message.
 */
export const CallPermissionSchema: GenMessage<CallPermission> =
  /*@__PURE__*/
  messageDesc(file_call_call_model, 13);

/**
 * @generated from enum com.gem.vcs.contract.CallPermission.AccessType
 */
export enum CallPermission_AccessType {
  /**
   * @generated from enum value: CAMERA = 0;
   */
  CAMERA = 0,

  /**
   * @generated from enum value: MIC = 1;
   */
  MIC = 1,

  /**
   * @generated from enum value: SCREEN_SHARING = 2;
   */
  SCREEN_SHARING = 2,
}

/**
 * Describes the enum com.gem.vcs.contract.CallPermission.AccessType.
 */
export const CallPermission_AccessTypeSchema: GenEnum<CallPermission_AccessType> =
  /*@__PURE__*/
  enumDesc(file_call_call_model, 13, 0);

/**
 * @generated from enum com.gem.vcs.contract.CallPermission.RequestStatus
 */
export enum CallPermission_RequestStatus {
  /**
   * @generated from enum value: APPROVED = 0;
   */
  APPROVED = 0,

  /**
   * @generated from enum value: DECLINED = 1;
   */
  DECLINED = 1,
}

/**
 * Describes the enum com.gem.vcs.contract.CallPermission.RequestStatus.
 */
export const CallPermission_RequestStatusSchema: GenEnum<CallPermission_RequestStatus> =
  /*@__PURE__*/
  enumDesc(file_call_call_model, 13, 1);

/**
 * @generated from message com.gem.vcs.contract.CallUiConfiguration
 */
export type CallUiConfiguration = Message<'com.gem.vcs.contract.CallUiConfiguration'> & {
  /**
   * @generated from field: com.gem.vcs.contract.CallUiConfiguration.ParticipantsControlType participantsControlType = 1;
   */
  participantsControlType: CallUiConfiguration_ParticipantsControlType;

  /**
   * @generated from field: bool raiseHandControlEnabled = 2;
   */
  raiseHandControlEnabled: boolean;

  /**
   * @generated from field: bool endCallForAllEnabled = 3;
   */
  endCallForAllEnabled: boolean;

  /**
   * @generated from field: bool permissionsAndAccessControlEnabled = 4;
   */
  permissionsAndAccessControlEnabled: boolean;

  /**
   * @generated from field: bool excludeParticipantsFromUserSearch = 5;
   */
  excludeParticipantsFromUserSearch: boolean;

  /**
   * @generated from field: bool showParticipantsNumberRestrictionBanner = 6;
   */
  showParticipantsNumberRestrictionBanner: boolean;

  /**
   * @generated from field: bool isP2P = 7;
   */
  isP2P: boolean;

  /**
   * @generated from field: bool showAllParticipants = 8;
   */
  showAllParticipants: boolean;

  /**
   * @generated from field: bool accessControlSectionVisible = 9;
   */
  accessControlSectionVisible: boolean;

  /**
   * @generated from field: bool showControlMic = 10;
   */
  showControlMic: boolean;

  /**
   * @generated from field: bool showControlCamera = 11;
   */
  showControlCamera: boolean;

  /**
   * @generated from field: bool showControlScreenSharing = 12;
   */
  showControlScreenSharing: boolean;

  /**
   * @generated from field: bool showControlParticipantListMobile = 13;
   */
  showControlParticipantListMobile: boolean;

  /**
   * @generated from field: bool changeParticipantRole = 14;
   */
  changeParticipantRole: boolean;

  /**
   * @generated from field: com.gem.vcs.contract.CallUiConfiguration.ParticipantGridDisplayMode participantGridDisplayMode = 15;
   */
  participantGridDisplayMode: CallUiConfiguration_ParticipantGridDisplayMode;

  /**
   * @generated from field: bool showCopyLinkOnPanel = 16;
   */
  showCopyLinkOnPanel: boolean;

  /**
   * @generated from field: bool showCopyLinkInMoreMenu = 17;
   */
  showCopyLinkInMoreMenu: boolean;

  /**
   * @generated from field: bool showControlBackground = 18;
   */
  showControlBackground: boolean;

  /**
   * @generated from field: bool showControlRecording = 19;
   */
  showControlRecording: boolean;

  /**
   * @generated from field: bool showControlInviteMembers = 20;
   */
  showControlInviteMembers: boolean;

  /**
   * @generated from field: bool isActiveControlParticipantListWeb = 21;
   */
  isActiveControlParticipantListWeb: boolean;

  /**
   * @generated from field: com.gem.vcs.contract.CallUiConfiguration.PreviewDisplayMode previewDisplayMode = 22;
   */
  previewDisplayMode: CallUiConfiguration_PreviewDisplayMode;

  /**
   * @generated from field: com.gem.vcs.contract.CallUiConfiguration.PermissionsSectionDisplayMode permissionsSectionDisplayMode = 23;
   */
  permissionsSectionDisplayMode: CallUiConfiguration_PermissionsSectionDisplayMode;

  /**
   * @generated from field: com.gem.vcs.contract.CallUiConfiguration.MemberListDisplayMode memberListDisplayMode = 24;
   */
  memberListDisplayMode: CallUiConfiguration_MemberListDisplayMode;

  /**
   * @generated from field: bool showCallWillEndSoonBanner = 25;
   */
  showCallWillEndSoonBanner: boolean;

  /**
   * @generated from field: bool showParticipantsLimitWillReachSoonBanner = 26;
   */
  showParticipantsLimitWillReachSoonBanner: boolean;

  /**
   * @generated from field: bool showParticipantsRestrictedLimitReachedBanner = 27;
   */
  showParticipantsRestrictedLimitReachedBanner: boolean;

  /**
   * @generated from field: bool showDurationLimitReachedBanner = 28;
   */
  showDurationLimitReachedBanner: boolean;
};

/**
 * Describes the message com.gem.vcs.contract.CallUiConfiguration.
 * Use `create(CallUiConfigurationSchema)` to create a new message.
 */
export const CallUiConfigurationSchema: GenMessage<CallUiConfiguration> =
  /*@__PURE__*/
  messageDesc(file_call_call_model, 14);

/**
 * @generated from enum com.gem.vcs.contract.CallUiConfiguration.ParticipantGridDisplayMode
 */
export enum CallUiConfiguration_ParticipantGridDisplayMode {
  /**
   * @generated from enum value: ADMIN = 0;
   */
  ADMIN = 0,

  /**
   * @generated from enum value: ALL = 1;
   */
  ALL = 1,
}

/**
 * Describes the enum com.gem.vcs.contract.CallUiConfiguration.ParticipantGridDisplayMode.
 */
export const CallUiConfiguration_ParticipantGridDisplayModeSchema: GenEnum<CallUiConfiguration_ParticipantGridDisplayMode> =
  /*@__PURE__*/
  enumDesc(file_call_call_model, 14, 0);

/**
 * @generated from enum com.gem.vcs.contract.CallUiConfiguration.ParticipantsControlType
 */
export enum CallUiConfiguration_ParticipantsControlType {
  /**
   * @generated from enum value: DISABLED = 0;
   */
  DISABLED = 0,

  /**
   * @generated from enum value: WITH_MAX_NUMBER = 1;
   */
  WITH_MAX_NUMBER = 1,

  /**
   * @generated from enum value: TOTAL_NUMBER = 2;
   */
  TOTAL_NUMBER = 2,
}

/**
 * Describes the enum com.gem.vcs.contract.CallUiConfiguration.ParticipantsControlType.
 */
export const CallUiConfiguration_ParticipantsControlTypeSchema: GenEnum<CallUiConfiguration_ParticipantsControlType> =
  /*@__PURE__*/
  enumDesc(file_call_call_model, 14, 1);

/**
 * @generated from enum com.gem.vcs.contract.CallUiConfiguration.PreviewDisplayMode
 */
export enum CallUiConfiguration_PreviewDisplayMode {
  /**
   * @generated from enum value: DEFAULT_PREVIEW = 0;
   */
  DEFAULT_PREVIEW = 0,

  /**
   * @generated from enum value: WEBINAR_PREVIEW = 1;
   */
  WEBINAR_PREVIEW = 1,
}

/**
 * Describes the enum com.gem.vcs.contract.CallUiConfiguration.PreviewDisplayMode.
 */
export const CallUiConfiguration_PreviewDisplayModeSchema: GenEnum<CallUiConfiguration_PreviewDisplayMode> =
  /*@__PURE__*/
  enumDesc(file_call_call_model, 14, 2);

/**
 * @generated from enum com.gem.vcs.contract.CallUiConfiguration.PermissionsSectionDisplayMode
 */
export enum CallUiConfiguration_PermissionsSectionDisplayMode {
  /**
   * @generated from enum value: CUSTOM_PERMISSIONS = 0;
   */
  CUSTOM_PERMISSIONS = 0,

  /**
   * @generated from enum value: WEBINAR_SPEAKERS = 1;
   */
  WEBINAR_SPEAKERS = 1,
}

/**
 * Describes the enum com.gem.vcs.contract.CallUiConfiguration.PermissionsSectionDisplayMode.
 */
export const CallUiConfiguration_PermissionsSectionDisplayModeSchema: GenEnum<CallUiConfiguration_PermissionsSectionDisplayMode> =
  /*@__PURE__*/
  enumDesc(file_call_call_model, 14, 3);

/**
 * @generated from enum com.gem.vcs.contract.CallUiConfiguration.MemberListDisplayMode
 */
export enum CallUiConfiguration_MemberListDisplayMode {
  /**
   * @generated from enum value: DEFAULT = 0;
   */
  DEFAULT = 0,

  /**
   * @generated from enum value: NAME_WITH_ROLE = 1;
   */
  NAME_WITH_ROLE = 1,
}

/**
 * Describes the enum com.gem.vcs.contract.CallUiConfiguration.MemberListDisplayMode.
 */
export const CallUiConfiguration_MemberListDisplayModeSchema: GenEnum<CallUiConfiguration_MemberListDisplayMode> =
  /*@__PURE__*/
  enumDesc(file_call_call_model, 14, 4);

/**
 * @generated from enum com.gem.vcs.contract.VideoResolution
 */
export enum VideoResolution {
  /**
   * @generated from enum value: P360 = 0;
   */
  P360 = 0,

  /**
   * @generated from enum value: P480 = 1;
   */
  P480 = 1,

  /**
   * @generated from enum value: P720 = 2;
   */
  P720 = 2,

  /**
   * @generated from enum value: P1080 = 3;
   */
  P1080 = 3,
}

/**
 * Describes the enum com.gem.vcs.contract.VideoResolution.
 */
export const VideoResolutionSchema: GenEnum<VideoResolution> =
  /*@__PURE__*/
  enumDesc(file_call_call_model, 0);
